import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Navigate, Outlet } from "react-router-dom";
import { isUserLoggedIn } from "../utils/helper";
import Header from '../components/header/banner/index';

const ProtectedRoutes = (props) => {

    const auth = isUserLoggedIn();

    const navigate = useNavigate();
    const locations = useLocation();

    useEffect(() => {
        // if (auth) {
        //     const isOrganizationProfilePending = sessionStorage.getItem('isOrganizationProfilePending');

        //     if (isOrganizationProfilePending === 'true') {
        //         navigate("/partner-org", {
        //             state: { tab: locations && locations.state && locations.state.tab ? locations.state.tab : "" },
        //         });
        //     }
        // }
    }, [locations.pathname])

    return auth ? <>
        <Header />
        <Outlet />
    </> : <Navigate to="/SuperAdmin" />;
};

export default ProtectedRoutes;
